import removeMd from 'remove-markdown';
import { IFrequentlyAskedQuestion } from 'types/cms';

// Per A2P-4353, Google's FAQPage guidance caps the number of questions worth marking up -
// independent of (and normally well under) MAX_FAQ_ITEMS in filterFaqsForContext.
export const MAX_FAQ_JSONLD_ITEMS = 10;

/**
 * Builds a schema.org FAQPage object for the FAQs actually rendered in the accordion, per
 * A2P-4353. Callers must pass only the already-filtered/visible FAQs (e.g. filterFaqsForContext's
 * output) so every entry here corresponds to a question on the page. The answer text uses
 * answerPlainText (markdown stripped by faqCollectionMapper) when available, falling back to
 * stripping the raw markdown here, so it matches what the accordion renders rather than raw
 * markdown syntax.
 */
export const buildFaqPageJsonLd = (faqs: IFrequentlyAskedQuestion[]) => {
  if (!faqs.length) {
    return undefined;
  }

  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.slice(0, MAX_FAQ_JSONLD_ITEMS).map(faq => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answerPlainText ?? removeMd(faq.answer, { gfm: false, useImgAltText: true }),
      },
    })),
  };
};
